import React from "react";

import "./Footer.css";

function Footer() {
  return (
    <div>
      <footer id="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6 sm:text-sm footer-contact">
                <h4>KNOW US MORE</h4>
                <h3>COSMICAL EVENT PLANNERS PRIVATE LIMITED</h3>
                <p>
                  131, PADMAVATI COLONY, <br />
                  PADMAVATI COLONY B, GOPALPURA
                  <br />
                  GOPALPURA BYPASS SHYAM NAGAR
                  <br />
                  JAIPUR 302019
                  <br />
                  CIN NO - UB2300RJ2024PTC093013
                  <br />
                  <br />
                  <strong>Phone:</strong> +91 9929925236
                  <br />
                  <strong>Email:</strong> cepteam@cosmicalevents.in
                  <br />
                </p>
              </div>

              <div className="col-lg-4 col-md-6 footer-newsletter d-flex flex-column align-items-center text-center">
                <h4>Join Our Newsletter</h4>
                <p>Know more about us from following links</p>
                {/* <form action="" method="post">
                  <input type="email" name="email" />
                  <input type="submit" value="Subscribe" />
                </form> */}
                <div className="social-links text-center text-md-right pt-3 pt-mt-5 mt-5">
                  <a
                    href="/"
                    className="twitter"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="ri-twitter-fill"></i>
                  </a>
                  <a
                    href="https://www.facebook.com/share/78gstUcTZ1UArbYQ/"
                    className="facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="ri-facebook-fill"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/cosmicalevents?igsh=MWhkdGJuYnVuYTR3cw=="
                    className="instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="ri-instagram-line"></i>
                  </a>
                  {/* <a href="#" className="google-plus">
                    <i className="ri-skype-fill"></i>
                  </a> */}
                  {/* <a href="#" className="linkedin">
                    <i className="ri-linkedin-fill"></i>
                  </a> */}
                </div>
              </div>
              <div className="col-lg-2 col-md-6 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li>
                    <i className="bx bx-chevron-right "></i> <a href="/" className=" decor-none">Home</a>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right "></i>{" "}
                    <a href="/About" className=" decor-none">About us</a>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right  "></i>{" "}
                    <a href="/contact-us" className=" decor-none">Contact Us</a>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right "></i>{" "}
                    <a href="/Terms_Of_use"  className=" decor-none" rel="noopener noreferrer">
                      Terms of service
                    </a>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right " ></i>{" "}
                    <a href="/Vision_Mission"  className=" decor-none" rel="noopener noreferrer">
                      Vision and Mission
                    </a>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right " ></i>{" "}
                    <a href="/Privacy_policy"  className=" decor-none" rel="noopener noreferrer">
                      Privacy policy
                    </a>
                  </li>
                </ul>
              </div>

              {/* <div className="col-lg-2 col-md-6 footer-links">
                <h4>Our Services</h4>
                <ul>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <a href="#">Web Design</a>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <a href="#">Web Development</a>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <a href="#">Product Management</a>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <a href="#">Marketing</a>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <a href="#">Graphic Design</a>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
